import { HeaderMapping, PropertyConfig } from '@amzn/awscat-portfolio-assessment-types';
import { Modal } from '@amzn/awsui-components-react';

import { constants } from '../../../../common/Localization';
import Table from '../../../../common/table/Table-index';
import { ColumnDefinition, ColumnTypes } from '../../../../common/table/types';
import { convertToDBUOM } from '../common-util/uomConversion';
import { convertNumberToString } from '../common-util/util';
import { diff } from './OverwriteHelpers';

interface Item {
    fileValue: string;
    portfolioValue: string;
    [id: string]: string;
}

const valueColumnDefinitions: ColumnDefinition<Item>[] = [
    {
        cell: item => item.portfolioValue,
        header: constants.OVERWRITE_MODAL_TABLE_HEADERS.PORTFOLIO_VALUE,
        id: 'portfolioValue',
        type: ColumnTypes.TEXT,
    }, {
        cell: item => item.fileValue,
        header: constants.OVERWRITE_MODAL_TABLE_HEADERS.FILE_VALUE,
        id: 'fileValue',
        type: ColumnTypes.TEXT,
    },
];

export const OverwriteModal = (visible: boolean, property: HeaderMapping, idFields: HeaderMapping[],
    propertiesConfigs: PropertyConfig[], onDismiss: (e: any) => void) => {
    if (!property || !property.idToValueMap || !property.fileIdToValuesMap) {
        return null;
    }
    const portfolioIdToValueMap = property.idToValueMap;
    const fileIdToValuesMap = property.fileIdToValuesMap;
    const items: Item[] = [];

    // Add ID columns at the start of columnDefinitions
    const idColumnDefinitions: ColumnDefinition<any>[] = [];
    const idProperties: string[] = [];

    idFields.forEach((idField: HeaderMapping) => {
        const label = propertiesConfigs.find((propertyConfig: PropertyConfig) => propertyConfig.value === idField.portfolioProperty)?.label;
        idProperties.push(idField.portfolioProperty);
        idColumnDefinitions.push({
            data: item => item[idField.portfolioProperty],
            cell: item => item[idField.portfolioProperty],
            header: label || idField.portfolioProperty,
            id: idField.portfolioProperty,
            type: ColumnTypes.TEXT,
        });
    });
    const columnDefinitions = [...idColumnDefinitions, ...valueColumnDefinitions];

    Object.keys(portfolioIdToValueMap).forEach(id => {
        if (!id) {
            return;
        }
        let fileValue: string = fileIdToValuesMap[id]?.[0];
        if (fileIdToValuesMap[id]?.[0] && !isNaN(Number(fileIdToValuesMap[id]?.[0]))) {
            fileValue = convertNumberToString(convertToDBUOM(Number(fileIdToValuesMap[id]?.[0]), property.fileUOM));
        }
        if (!diff(portfolioIdToValueMap[id]?.toString(), fileValue)) {
            return;
        }
        let ids: {[id: string]: string} = {};
        if (idFields.length > 1) {
            // For composite keys, id is the result of JSON.stringify
            // i.e. a composite key in app-to-server mapping can be "{"applicationId": "A1", "serverId": "S1"}"
            ids = JSON.parse(id);
        } else {
            const singleIdProperty = idFields[0]?.portfolioProperty;
            ids[singleIdProperty] = id;
        }
        items.push({
            fileValue,
            portfolioValue: portfolioIdToValueMap[id]?.toString(),
            ...ids,
        });
    });
    const content = (
        <Table
            resourceName='Overwrite'
            items={items}
            columnDefinitions={columnDefinitions}
        />
    );
    return (
        <Modal
            visible={visible}
            header={`${constants.OVERWRITE_MODAL_TITLE} - ${property.portfolioPropertyLabel}`}
            onDismiss={onDismiss}
        >
            {content}
        </Modal>
    );
};
